import { PopupTypeValue } from '@constants/popupTypes'
import helpers from '@lib/analytics/amplitude/helpers'

const { sendEvent } = helpers

const popupVisible = (popupType: PopupTypeValue, screen: string): void => {
  sendEvent('popup-visible', {
    popupType,
    screen,
    timestamp: new Date().toISOString(),
  })
}

const popupClick = (popupType: PopupTypeValue, ctaLabel: string, popupOutcome: string): void => {
  sendEvent('popup-click', {
    popupType,
    ctaLabel,
    popupOutcome,
  })
}

export default {
  popupVisible,
  popupClick,
}
